import { ComparisonBlock } from "@foodpilot/foods";
import { Box, Stack, useTheme, useMediaQuery } from "@mui/material";
import { ScoreWithVariation } from "src/services/ScoreService";
import { ReactNode } from "react";
import { NumericalScoreValue } from "src/api/client-api/olapScores/olapScoresSchema";

type PrevScoreLayoutProps = {
    scoreWithVariation: ScoreWithVariation | undefined;
    total: NumericalScoreValue;
    prevScore: NumericalScoreValue;
    unit: string | undefined;
    prevCampaignLabel?: string;
    children: ReactNode;
};
export const PrevScoreLayout = (props: PrevScoreLayoutProps) => {
    const { children, scoreWithVariation, unit, prevCampaignLabel } = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const doesTotalExist = props.total !== null;
    const doesPrevExist = props.prevScore !== null;

    if (doesTotalExist === false) {
        return children;
    }

    // En mobile, on affiche juste le contenu sans la carte
    if (isMobile) {
        return (
            <Box
                sx={{
                    padding: theme.spacing(2),
                }}
            >
                {children}
            </Box>
        );
    }

    return (
        <Stack flexDirection="row" gap={theme.spacing(4)}>
            {doesPrevExist && (
                <Stack
                    sx={{
                        width: "170px",
                        minWidth: "170px",
                        "& .comparison-block-wrapper": {
                            width: "100%",
                        },
                    }}
                    direction="column"
                    justifyContent="flex-start"
                    gap={theme.spacing(3)}
                >
                    <ComparisonBlock
                        currentValue={props.total ?? 0}
                        comparedTo={{
                            value: props.prevScore ?? 0,
                            unit,
                            label: prevCampaignLabel,
                        }}
                        improvement={
                            scoreWithVariation?.improvement ??
                            (scoreWithVariation?.displayMode === "carbon" ? "decrease" : "increase")
                        }
                        layout={{
                            direction: "vertical",
                            size: "L",
                        }}
                    />
                </Stack>
            )}
            <Box
                display="flex"
                flexDirection="column"
                sx={{
                    width: "100%",
                    border: `1px solid ${theme.palette.grey[500]}`,
                    borderRadius: "12px",
                    padding: theme.spacing(6),
                    justifyContent: "center",
                }}
            >
                {children}
            </Box>
        </Stack>
    );
};
